import { createFileRoute } from '@tanstack/react-router';
import { TranslateStructure } from '@/features/admin/TranslateStructure';

export const Route = createFileRoute('/_app/translate-structure')({ component: TranslateStructure });
